import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { BusinessUnitFormData } from "../interfaces/businessUnits";
import { camelToSnake } from "../utils/CamelToSnake";

export const createBusinessUnit = (payload: BusinessUnitFormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/business-units`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getBusinessUnits = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/business-units`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getBusinessUnitById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/business-units/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateBusinessUnit = (
  id: number | string,
  payload: BusinessUnitFormData
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/business-units/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deleteBusinessUnit = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .delete(`${BASE_URL}/api/v1/business-units/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

